export default __webpack_public_path__ + "static/media/chatbot_animated.80c11941.svg";